/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as JoinRidersRouteImport } from './routes/join-riders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RidersRouteImport } from './routes/riders'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ShipmentsRouteImport } from './routes/shipments'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRidersRoute = JoinRidersRouteImport.update({
  id: '/join-riders',
  path: '/join-riders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RidersRoute = RidersRouteImport.update({
  id: '/riders',
  path: '/riders',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ShipmentsRoute = ShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/join-riders': typeof JoinRidersRoute
  '/login': typeof LoginRoute
  '/riders': typeof RidersRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/join-riders': typeof JoinRidersRoute
  '/login': typeof LoginRoute
  '/riders': typeof RidersRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/customers': typeof CustomersRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/join-riders': typeof JoinRidersRoute
  '/login': typeof LoginRoute
  '/riders': typeof RidersRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/blog'
    | '/customers'
    | '/dashboard'
    | '/faq'
    | '/join-riders'
    | '/login'
    | '/riders'
    | '/settings'
    | '/shipments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/blog'
    | '/customers'
    | '/dashboard'
    | '/faq'
    | '/join-riders'
    | '/login'
    | '/riders'
    | '/settings'
    | '/shipments'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/blog'
    | '/customers'
    | '/dashboard'
    | '/faq'
    | '/join-riders'
    | '/login'
    | '/riders'
    | '/settings'
    | '/shipments'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  BlogRoute: typeof BlogRoute
  CustomersRoute: typeof CustomersRoute
  DashboardRoute: typeof DashboardRoute
  FaqRoute: typeof FaqRoute
  JoinRidersRoute: typeof JoinRidersRoute
  LoginRoute: typeof LoginRoute
  RidersRoute: typeof RidersRoute
  SettingsRoute: typeof SettingsRoute
  ShipmentsRoute: typeof ShipmentsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join-riders': {
      id: '/join-riders'
      path: '/join-riders'
      fullPath: '/join-riders'
      preLoaderRoute: typeof JoinRidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/riders': {
      id: '/riders'
      path: '/riders'
      fullPath: '/riders'
      preLoaderRoute: typeof RidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shipments': {
      id: '/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof ShipmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  BlogRoute: BlogRoute,
  CustomersRoute: CustomersRoute,
  DashboardRoute: DashboardRoute,
  FaqRoute: FaqRoute,
  JoinRidersRoute: JoinRidersRoute,
  LoginRoute: LoginRoute,
  RidersRoute: RidersRoute,
  SettingsRoute: SettingsRoute,
  ShipmentsRoute: ShipmentsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
